import { AppItem, AppItemList, DictStrict } from "../../../types";

export const getUpsertedNestedItemList = <
  DataKey extends string,
  ItemType extends AppItem<DataKey>
>({
  dataKeyName,
  newItem,
  groupedByValue,
  nestedItemList,
}: {
  newItem?: ItemType;
  groupedByValue?: string;
  /**
   * Name of property storing nested entity data (and optional
   * reactionCount property)
   *
   * @FIXME
   * We have to specify this key name because of inconsistency in
   * all available Items shapes (nested data is stored under entity
   * name property). Unifing that property name and setting it
   * for example to "data" would simplify app data structures.
   */
  dataKeyName: DataKey;
  nestedItemList: DictStrict<AppItemList<DataKey, ItemType>>;
}): DictStrict<AppItemList<DataKey, ItemType>> => {
  if (!newItem || !groupedByValue) return nestedItemList;

  const listToUpsert = nestedItemList[groupedByValue];

  return listToUpsert
    ? {
        ...nestedItemList,
        [groupedByValue]: {
          ...listToUpsert,
          items: {
            ...listToUpsert.items,
            [newItem[dataKeyName].id]: newItem,
          },
        },
      }
    : nestedItemList;
};
